import React from 'react';
import Tempapp from "./components/tempapp";

function App() {
return (
  <Tempapp />
)
}

export default App;
